import React, {Component} from "react";
import {isNull, isSuperuser} from "../../utils/utils";
import {Button, ThemeProvider} from "@mui/material";
import {defaultTheme} from "../gammaviewer/themes";
import {message, Modal, Select} from "antd";
import {get} from "../../helper/request";
import {urls} from "../../utils/urls";
import cookie from "react-cookies";
import {deleteOrganisation, loadUsers} from "../../redux_actions/users.action";
import {connect} from "react-redux";

const Option = Select.Option;

class DeleteOrganisationModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            showDeleteModal: false,
            name: "",
            ownerName: "",
            error_msg: "",
            org_options: [],
            owner_options: []
        }
        this.is_superuser = isSuperuser();
    }

    componentDidMount() {
        this.getAllOrgsOptions();
        this.getAllOwnerOptions();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.allOrganisations !== this.props.allOrganisations) {
            this.getAllOrgsOptions();
        }
        if (prevProps.allGroups !== this.props.allGroups) {
            this.getAllOwnerOptions();
        }
        if (prevState.name !== this.state.name) {
            this.getAllOwnerOptions();
        }
        if (prevState.showDeleteModal !== this.state.showDeleteModal) {
            this.getAllOrgsOptions();
            this.getAllOwnerOptions();
        }
    }

    getAllOrgsOptions = () => {
        let options = [];
        if (this.props.allOrganisations.length > 0) {
            this.props.allOrganisations.forEach(val => {
                if (isNull(val)) return;
                if (val.name !== cookie.load("organisation")) {
                    options.push(<Option value={val.name}>{val.name}</Option>)
                }
            })
        }
        this.setState({org_options: options})
        if (options.length === 0) {
            this.setState({error_msg: "No organisation to delete"})
        }
    }

    getAllOwnerOptions = () => {
        let options = [];
        if(Object.keys(this.props.allGroups).length > 0) {
            Object.values(this.props.allGroups).forEach(val => {
                if (isNull(val)) return;
                const flag = this.props.allOrganisations.some(value => value && value.id === val.organisation && value.name === this.state.name);
                if (!flag && val.organisation !== cookie.load("organisation_id")) {
                    options.push(<Option value={val.name}>{val.name}</Option>)
                }
            })
        }
        this.setState({owner_options: options})
        if (options.length === 0) {
            this.setState({error_msg: "No group present in other organisation to which ownership can be transferred. Create one and then delete org."})
        }
    }

    closeModal = () => {
        this.setState({
            showDeleteModal: false, loading: false, name: "", error_msg: "", ownerName: "",
            org_options: [], owner_options: []
        });
    }

    deleteOrganisation = async () => {
        if (!this.state.name) return

        this.setState({loading: true})
        let url = `${urls.DELETE_ORGANISATION}${this.state.name}/${this.state.ownerName}/`;
        await get(url)
            .then(response => {
                this.props.dispatch(deleteOrganisation(this.state.name));
                this.props.dispatch(loadUsers());
                message.success(`Successfully deleted organisation "${this.state.name}"`)
                this.closeModal();
            })
            .catch(err => {
                if(err?.response?.status === 400 && err?.response?.data){
                    this.setState({error_msg: err?.response?.data})
                } else {
                    this.setState({error_msg: "Couldn't delete organisation"})
                }
            })
            .finally(() => {
                this.setState({loading: false})
            })
    }

    handleOrganisationChange = (value) => {
        this.setState({name: value});
    }

    handleOwnerChange = (value) => {
        this.setState({ownerName: value})
    }

    render() {

        if (!this.is_superuser) return null;

        return (
            <React.Fragment>
                <ThemeProvider theme={defaultTheme}>
                    <Button
                        color="primary"
                        variant="outlined"
                        size="small"
                        onClick={() => this.setState({showDeleteModal: true})}
                    >
                        Delete Org
                    </Button>
                    <Modal
                        title="Delete Existing Organisation"
                        visible={this.state.showDeleteModal}
                        onCancel={this.closeModal}
                        onOk={this.deleteOrganisation}
                        confirmLoading={this.state.loading}
                        okText="Delete Organisation"
                        okButtonProps={{disabled: !(this.state.name) || !(this.state.ownerName)}}
                    >
                        <div style={{color: "#f00", fontSize: 12, marginBottom: 20, fontStyle: "italic"}}>
                            *All organisation related data like CASES and other tables data is going to be deleted
                            permanently, and can not be recovered.
                        </div>
                        <div>
                            <label>Select organisation to be deleted: </label>
                            <Select
                                value={this.state.name}
                                placeholder="Select Organisation"
                                onChange={this.handleOrganisationChange}
                                style={{width: '50%', marginLeft: 18}}
                                id="organisation_change"
                            >
                                {this.state.org_options}
                            </Select>
                        </div>
                        <div style={{marginTop: 25}}>
                            <label>Select new owner of slides: </label>
                            <Select
                                value={this.state.ownerName}
                                placeholder="Select Owner"
                                onChange={this.handleOwnerChange}
                                style={{width: '50%', marginLeft: 60}}
                                id="ownership_change"
                                disabled={this.state.name === ""}
                            >
                                {this.state.owner_options}
                            </Select>
                        </div>
                        <div style={{fontSize: 12, marginTop: 30, marginBottom: 15, fontStyle: "italic"}}>
                            *These are non-personal groups of other organisations to which you may transfer the
                            ownerships of scanned slides. If no group present, create one and make it owner of slides
                            owned
                            by the organisation selected for permanent deletion
                        </div>
                        <div style={{color: "red"}}>{this.state.error_msg}</div>
                    </Modal></ThemeProvider>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        allGroups: state.searchUserReducer.groups,
        allOrganisations: state.searchUserReducer.organisations,
    };
};

export default connect(mapStateToProps)(DeleteOrganisationModal);